module.exports = __webpack_public_path__ + "static/media/emptylist.6ba7e26e.png";